<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    @opened="initEditor"
    @closed="closeDig"
    append-to-body
  >
    <el-form :model="dataForm"  :rules="dataRule" ref="dataForm"
             label-width="132px">
        <el-row>
            <el-col :span="12">
                <el-form-item label="数据集编号：" prop="code">
                    <el-input v-model="dataForm.code" placeholder="数据集编号"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="是否为列表：" prop="hasMultiLine">
                    <el-select v-model="dataForm.hasMultiLine" placeholder="是否为列表">
                        <el-option label="否" :value="false"></el-option>
                        <el-option label="是" :value="true"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row v-if="$customFormGlobalConfig.showHistoryConfig && parentShowHistoryTag != 0">
            <el-col :span="12" v-if="!dataForm.hasMultiLine">
                <el-form-item label="是否是历史记录：" prop="historyDataset">
                    <el-select v-model="dataForm.historyDataset" placeholder="是否是历史记录">
                        <el-option label="否" :value="false"></el-option>
                        <el-option label="是" :value="true"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12" v-if="!dataForm.hasMultiLine && dataForm.historyDataset">
                <el-form-item label="关联数据集：" prop="parentId">
                    <el-select v-model="dataForm.parentId" placeholder="关联数据集"
                               style="display: block;margin-bottom: 10px">
                        <el-option
                            v-for="item in parentList"
                            :key="item.id"
                            :label="item.code"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form-item label="SQL语句：" prop="sqlClause">
                    <textarea
                            v-model="dataForm.sqlClause"
                            rows="20"
                            placeholder="SQL语句"
                            ref="sqlEditor"
                            class="codesql"
                    ></textarea>
                </el-form-item>
            </el-col>
        </el-row>



    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>

    import 'codemirror/addon/edit/matchbrackets'
    import 'codemirror/addon/selection/active-line'
    import 'codemirror/mode/sql/sql'
    import 'codemirror/addon/hint/sql-hint'
    import 'codemirror/addon/hint/show-hint'
    import CodeMirror from 'codemirror/lib/codemirror'
    import {aesEncrypt,aesDecrypt} from '../../utils/utils'
    import {
        apiCustomformFromdatasetGet,
        apiCustomformFromdatasetListSingleData,
        apiCustomformFromdatasetSave
    } from "../../server/formConfig";
    const datasetValue = {
        id: '',
        formId: '',
        code: '',
        sqlClause: '',
        hasMultiLine: false,
        historyDataset: false,
    };
    export default {
        props: ['mainContentViewHeight'],
        data() {
            return {
                visible: false,
                dataForm: datasetValue,
                dataRule: {
                    code: [
                        {required: true, message: '数据集编号不能为空', trigger: 'blur'}
                    ],
                    sqlClause: [
                        {required: true, message: 'sqlClause不能为空', trigger: 'blur'}
                    ],
                },
                sqlEditor:null,
                parentList: [], //关联数据集筛选列表数据
                parentShowHistoryTag: false, //外部传进来的是否展示历史变更
            }
        },
      methods: {
            //获取关联数据集筛选列表数据
          getParentList() {
              if(!this.$customFormGlobalConfig.showHistoryConfig) return

              apiCustomformFromdatasetListSingleData(this.dataForm.formId, this.dataForm.id).then((res) => {
                  if(res.data.code === '1') {
                      this.parentList = res.data.data
                  }
              })
          },
            getDataset() {
                if (this.dataForm.id) {
                    const that = this
                    apiCustomformFromdatasetGet(this.dataForm.id).then(({data}) => {
                        if (data && data.code === '1') {
                            this.dataForm = {...data.data};
                            this.dataForm.sqlClause = aesDecrypt(this.dataForm.sqlClause)
                            this.$nextTick(() => {
                                console.log('给sqlEditor赋值了===', that.sqlEditor)
                                that.sqlEditor.setValue(this.dataForm.sqlClause);
                            })

                        } else {
                            this.dataForm = datasetValue
                        }
                    })
                } else {
                    this.dataForm.id='';
                    this.dataForm.code='';
                    this.dataForm.sqlClause='';
                    this.dataForm.hasMultiLine=false;
                    this.dataForm.historyDataset = false;
                }
            },
            init(id, formId, showHistoryTag) {
                this.dataForm = datasetValue
                this.dataForm.id = id || ''
                this.dataForm.formId = formId || ''
                this.parentShowHistoryTag = showHistoryTag || 0
                this.visible = true
            },
            // 表单提交
            dataFormSubmit() {
                var dataForm = JSON.parse(JSON.stringify(this.dataForm))
                dataForm.sqlClause = aesEncrypt(this.sqlEditor.getValue())
                apiCustomformFromdatasetSave(dataForm).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                });
            },
           initEditor(){

                 const mime="text/x-mysql";
                 this.sqlEditor=CodeMirror.fromTextArea(this.$refs.sqlEditor,{
                       mode:mime,
                       theme: "ambiance",
                       indentWithTabs:true,
                       smartIndent:true,
                       lineNumbers:true,
                       matchBrackets:true,
                       lineWrapping:true,
                       line:true,
                       spellcheck:true,
                       scrollbarStyle:null,
                       hintOptions: {
                         completeSingle: false
                       }
                   });
                 let _that=this;
                 _that.sqlEditor.on('inputRead',()=>{
                   _that.sqlEditor.showHint();
                 })

               this.getDataset();
                 this.getParentList();
           },
          closeDig(){
              if (this.sqlEditor){
                this.sqlEditor.toTextArea();
              }
            this.sqlEditor=null;
          }
        }
    }
</script>
<style>
.CodeMirror-hints{
  z-index: 999999 !important;
}
</style>

